export const DEFAULT_IMPACT_BACKGROUND_GRADIENT = {
	baseColor: "#B2B2B2",
	tintColor: "#FEFEFE",
	tertiaryColor: "#999999",
};
